<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <!-- TABLA DOCUMENTO -->
          <template>
            <div v-if="loading">
              <loading></loading>
            </div>
            <grid-captura
              :key="gridDocumento"
              :rowsTable="rowsTable"
              :contratoId="contratoId"
            ></grid-captura>
          </template>
          <!-- TABLA DOCUMENTO -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import GridCaptura from "@/modules/captura/views/seguimiento/captura/GridCaptura.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "scan-tab",

  components: {
    GridCaptura,
    Loading,
  },

  props: {},

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
  },

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
  },
};
</script>
